import {variables} from '../common/variables';

import {cl, toggleMapList} from '../common/functions';
import {markeractiveState} from './map-events';

const search = (markersArray, markersCluster) => {
  /*------------[SEARCH] Toggle on mobile------------*/
  if (window.innerWidth >= variables.breakpoint) {
    if (variables.shortcodeSearchTypeValue !== 'custom') {
      let searchBar = document.querySelector('.leaflet-geosearch-bar:not(.leaflet-control)');
      if (searchBar !== null) {
        let closeSearchResults = element => {
          element.innerHTML = '';
          element.classList.remove('active');
        };
        let searchElement = document.querySelector('.leaflet-geosearch-bar:not(.leaflet-control) .results');
        // prettier-ignore
        window.addEventListener("click", (event) => {
          if (event.target !== searchBar) {
            closeSearchResults(searchElement);
          }
        }, false);
        let searchContainer = document.getElementById('stores__search');
        searchContainer.innerHTML = '';
        searchContainer.appendChild(searchBar);
      }
    }
  } else {
    // prettier-ignore
    variables.storeTab.addEventListener('click', () => {
      toggleMapList(variables.storeTab, variables.mapTab, variables.storeContainer, variables.mapContainer);
    }, false);
    // prettier-ignore
    variables.mapTab.addEventListener('click', () => {
      toggleMapList(variables.mapTab, variables.storeTab, variables.mapContainer, variables.storeContainer);
    }, false);

    if (variables.shortcodeSearchTypeValue !== 'custom') {
      let searchBar = document.querySelector('.leaflet-geosearch-bar:not(.leaflet-control)');
      if (searchBar !== null) {
        let searchContainer = document.getElementById('searchTab__search');
        searchContainer.innerHTML = '';
        searchContainer.appendChild(searchBar);
      }
    }
  }
  /*------------[SEARCH] Custom search------------*/
  if (variables.shortcodeSearchTypeValue === 'custom') {
    let searchShop;
    let typingTimer; //timer identifier
    let doneTypingInterval = 250; //time in ms (1 seconds)

    if (window.innerWidth >= variables.breakpoint) {
      searchShop = document.querySelector('#stores__search #search__shop');
    } else {
      searchShop = document.querySelector('#searchTab__search #search__shop');
    }
    //event à chaque fois qu'un caractère est tapé dans l'input
    let list_array = document.querySelectorAll('#stores__container .container__item');
    // prettier-ignore
    searchShop.addEventListener('input', () => {
      clearTimeout(typingTimer);
      typingTimer = setTimeout(function () {
        // Filtrage de la liste
        for (let i = 0; i < list_array.length; i++) {
          matchingEntities(list_array[i]);
        }
        // filtrage des markers
        [...markersArray].forEach(marker => {
          matchingMarkers(marker);
        });
        // reset de l'état actif des markers
        const selectedItem = document.querySelector(".container__item.selected");
        markeractiveState(selectedItem, markersArray, markersCluster);
      }, doneTypingInterval);
    }, false);

    //affiche/cache les item en fonction du match du texte de l'input
    const matchingEntities = item => {
      let normalizedString = searchShop.value.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
      let str = new RegExp(normalizedString, 'gi');
      let itemText = item
        .querySelector('.text__title')
        .innerHTML.normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '');
      let itemSecondText = item.querySelector('.text__subtitle');
      if (itemSecondText) {
        itemText = itemText + itemSecondText
          .innerHTML.normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '');
      }
      if (itemText.match(str)) {
        item.dataset.display = 'true';
        setTimeout(() => {
          item.style.opacity = '1';
        }, 300);
      } else {
        item.style.opacity = '0';
        setTimeout(() => {
          item.dataset.display = 'false';
        }, 300);
      }
    };

    const matchingMarkers = (marker) => {
      const normalizedString = searchShop.value.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
      const str = new RegExp(normalizedString, 'gi');
      let markerText = marker.options.name.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

      if (markerText.match(str)) {
        // check si des filtres ne sont pas actifs
        const filterList = document.querySelectorAll(`ul.filters__list li.list__element[data-checked="checked"]`);
        if (filterList.length !== 0) {
          [...filterList].forEach(filter => {
            if (marker.options.tags.includes(filter.dataset.value)) {
              markersCluster.addLayer(marker);
            }
          });
        } else {
          markersCluster.addLayer(marker);
        }
      } else {
        markersCluster.removeLayer(marker);
      }
    }
  }
};
export {search};
